import { 
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useFormContext } from "react-hook-form";
import { FormValues } from "../TokenForm";

export function TokenSymbolField() {
  const form = useFormContext<FormValues>();

  return (
    <FormField
      control={form.control}
      name="symbol"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center space-x-2">
            <FormLabel>Token Symbol</FormLabel>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <HelpCircle className="h-4 w-4 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent>
                  <p className="max-w-xs">A short abbreviation for your token (e.g., "BTC" or "ETH"). This will be your token's ticker symbol on exchanges.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <FormControl>
            <Input
              {...field}
              value={field.value?.toUpperCase() || ""}
              placeholder="Enter token symbol"
              onChange={(e) => {
                const value = e.target.value.toUpperCase();
                field.onChange(value);
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
